import React from 'react'
import PACHero from '../system/generic-hero/pac-hero'
import PACProfile from './pac-profile'
import LoweryProfile from './lowery-profile'
import VenueInfo from '../../models/venue-info'

const VenueProfiles = ({ profiles }: { profiles: VenueInfo[] }) => {
  const pacVenueProfile = profiles.find(profile => profile.venueId === 'pac')
  const loweryVenueProfile = profiles.find(profile => profile.venueId === 'lowery')

  if (!pacVenueProfile) {
    throw 'PAC venue profile could not be found'
  }

  if (!loweryVenueProfile) {
    throw 'Lowery venue profile could not be found'
  }

  return (
    <>
      <PACHero>
        <h1>
          <b>Venue</b> Info
        </h1>
      </PACHero>
      <PACProfile profile={pacVenueProfile} />
      <LoweryProfile profile={loweryVenueProfile} />
    </>
  )
}

export default VenueProfiles
